"use strict";

var _classCallCheck = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _defineProperty = require("/home/keoadmin/agent/_work/67/s/node_modules/@babel/runtime/helpers/defineProperty.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
exports.ISODayParser = void 0;
var _index = require("../../../setISODay.js");
var _Parser = require("../Parser.js");
var _utils = require("../utils.js");

// ISO day of week
var ISODayParser = /*#__PURE__*/function (_Parser$Parser) {
  _inherits(ISODayParser, _Parser$Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case "i":
        case "ii":
          // 02
          return (0, _utils.parseNDigits)(token.length, dateString);
        // 2nd
        case "io":
          return match.ordinalNumber(dateString, {
            unit: "day"
          });
        // Tue
        case "iii":
          return (0, _utils.mapValue)(match.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback);
        // T
        case "iiiii":
          return (0, _utils.mapValue)(match.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback);
        // Tu
        case "iiiiii":
          return (0, _utils.mapValue)(match.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback);
        // Tuesday
        case "iiii":
        default:
          return (0, _utils.mapValue)(match.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = (0, _index.setISODay)(date, value);
      date.setHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(_Parser.Parser);
exports.ISODayParser = ISODayParser;